import { useEffect } from 'react'

export function useIOSScrollFix(ref: React.RefObject<HTMLElement | null>) {
  useEffect(() => {
    const el = ref.current
    if (!el) return

    const clampAtEdges = () => {
      const max = el.scrollHeight - el.clientHeight
      if (max <= 0) return
      if (el.scrollTop <= 0)
        el.scrollTop = 1 // nudge off the top edge
      else if (el.scrollTop >= max) el.scrollTop = max - 1 // nudge off bottom edge
    }

    // Nudge now and whenever a new gesture starts
    clampAtEdges()
    const onTouchStart = clampAtEdges
    const onScroll = clampAtEdges
    const onResize = clampAtEdges

    el.addEventListener('touchstart', onTouchStart, { passive: true })
    el.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onResize)

    return () => {
      el.removeEventListener('touchstart', onTouchStart)
      el.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onResize)
    }
  }, [ref])
}
